// extracted by mini-css-extract-plugin
export default {"employee-container":"TimeActivities_employee-container__0jebz","monthly-summary-header":"TimeActivities_monthly-summary-header__CSxA5"};